import React from 'react'

import config from 'config/apps'

import { LinkWithoutUnderline } from '../MenuAlert/LinkWithoutUnderline'
import { MenuAlert } from '../MenuAlert/MenuAlert'

export const FlexOrderAlert = () => (
  <MenuAlert title="You adjusted recipe portions in the app for this order">
    This portion feature is part of a 2-week beta trial in the app. Editing on the website will
    remove your portion changes. Please use the{' '}
    <LinkWithoutUnderline
      href={`https://geo.itunes.apple.com/gb/app/gousto-uks-no1-recipe-kit/id${config.appStoreId}?mt=8`}
    >
      Gousto app
    </LinkWithoutUnderline>{' '}
    to make updates.
  </MenuAlert>
)
